import React from 'react';
import { Button } from 'antd';

/** 会标已放置时的底部条：打开发送弹窗 */
export default function DashboardSendLocationBanner({
  plantTarget,
  planted,
  isMobile,
  sendingLocation,
  onCancel,
  onConfirm
}) {
  if (!plantTarget) return null;
  const rally = !!plantTarget.rally;
  return (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        bottom: isMobile ? 96 : 28,
        transform: 'translateX(-50%)',
        zIndex: 1100,
        background: 'rgba(255,255,255,.96)',
        border: '1px solid #cbd5e1',
        borderRadius: 10,
        boxShadow: '0 8px 24px rgba(15,23,42,.16)',
        padding: '10px 14px',
        minWidth: 280,
        maxWidth: '90vw'
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a', marginBottom: 4 }}>
        {rally ? '会标已放置' : `向「${plantTarget.name || '队员'}」发送位置`}
      </div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>
        {planted
          ? `坐标：${planted.lat.toFixed(6)}, ${planted.lng.toFixed(6)}`
          : '鼠标已变为水滴：在地图上点击放置，可再次点击调整位置'}
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <Button size="small" onClick={onCancel}>取消</Button>
        <Button
          size="small"
          type="primary"
          loading={sendingLocation}
          disabled={!planted}
          onClick={onConfirm}
        >
          发送位置
        </Button>
      </div>
    </div>
  );
}
